import type { SyntheticEvent } from 'react';

import { OrientationEnum, PaperFormatEnum } from '@e-socna/data-layer';
import type { ContentOriginId } from '@e-socna/data-layer';

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

import { useReferencesContext } from '../../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

export interface Props {
  readonly contentOriginId: ContentOriginId;
  readonly paperFormat: PaperFormatEnum;
  readonly hasPagebreakAfter: boolean;
  readonly hasPagebreakBefore: boolean;
  readonly isOpen: boolean;
  readonly onClose: (event: Readonly<SyntheticEvent>) => void;
  readonly orientation: OrientationEnum;
}

export const SectionDetailsDialog = ({
  contentOriginId,
  paperFormat,
  hasPagebreakAfter,
  hasPagebreakBefore,
  isOpen,
  onClose: handleClose,
  orientation,
}: Readonly<Props>) => {
  const { contentOriginsIdMap } = useReferencesContext();

  const contentOriginLabel =
    contentOriginsIdMap[contentOriginId]?.label ?? 'Inconnu';

  return (
    <Dialog onClose={handleClose} open={isOpen}>
      <DialogTitle>Informations sur cette section</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Origine de la section: {contentOriginLabel}
        </DialogContentText>
        <DialogContentText>
          Orientation:{' '}
          {orientation === OrientationEnum.Landscape ? 'Paysage' : 'Portrait'}
        </DialogContentText>
        <DialogContentText>
          Format: {paperFormat === PaperFormatEnum.A3 ? 'A3' : 'A4'}
        </DialogContentText>
        <DialogContentText>
          Saut de page avant: {hasPagebreakBefore ? 'Oui' : 'Non'}
        </DialogContentText>
        <DialogContentText>
          Saut de page après: {hasPagebreakAfter ? 'Oui' : 'Non'}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button onClick={handleClose} size="large" variant="outlined">
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
